import React, { useEffect, useState } from 'react';
import { Box, Typography, Checkbox, Table } from '@mui/material';
import TextInput from '../../../inputs/textInput';

interface FormTransportationProps {
  data?: {
    output?: {
      delivery_condition?: string;
      order_reference?: string;
      pallets_exchange?: string;
    };
  };
}

const FormTransportation = ({ data }: FormTransportationProps) => {
  const [formData, setFormData] = useState({
    delivery_condition: '',
    order_reference: '',
    pallets_exchange: '',
  });

  useEffect(() => {
    setFormData({
      delivery_condition: data?.output?.delivery_condition || '',
      order_reference: data?.output?.order_reference || '',
      pallets_exchange: data?.output?.pallets_exchange || '',
    });
  }, [data]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        width: '100%',  
        justifyContent: 'space-around',
        bgcolor: 'background.lightGrey',
        p: 3.125, // 25px
        borderRadius: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625 }}>
        <Typography
          htmlFor="delivery_condition"
          component="label"
          sx={{
            fontSize: (theme: any) => theme.typography.fontSizes.body,
            width: '100px',
            color: 'text.blue',
          }}
        >
          PASTABA
        </Typography>
        <TextInput
          id="delivery_condition"
          name="delivery_condition"
          multiline
          minRows={3}
          value={formData.delivery_condition + (formData?.pallets_exchange ? '\n\nPALLETS EXCHANGE!!!' : '')}
          onChange={handleChange}
          sx={{
            width: '400px',
            minHeight: '80px',
            resize: 'vertical',
            p: 1,
            fontSize: (theme: any) => theme.typography.fontSizes.body,
            lineHeight: 1.4,
            whiteSpace: 'pre-wrap',
            boxSizing: 'border-box',
            color: formData?.pallets_exchange ? 'text.red' : 'text.dark',
            textTransform: formData?.pallets_exchange ? 'uppercase' : 'none',
            fontWeight: formData?.pallets_exchange ? 700 : 'normal',
            '& .MuiInputBase-input': {
              color: formData?.pallets_exchange ? 'text.red' : 'text.dark',
              textTransform: formData?.pallets_exchange ? 'uppercase' : 'none',
              fontWeight: formData?.pallets_exchange ? 700 : 'normal',
            },
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625 }}>
        <Typography
          htmlFor="invoiceNotes"
          component="label"
          sx={{
            fontSize: (theme: any) => theme.typography.fontSizes.body,
            width: '100px',
            color: 'text.blue',
          }}
        >
          SĄSK. PASTABA
        </Typography>
        <TextInput
          id="invoiceNotes"
          name="invoiceNotes"
          multiline
          minRows={3}
          sx={{
            width: '400px',
            minHeight: '80px',
            resize: 'vertical',
            p: 1,
            fontSize: (theme: any) => theme.typography.fontSizes.body,
            lineHeight: 1.4,
            whiteSpace: 'pre-wrap',
            boxSizing: 'border-box',
            color: 'text.black',
            '& .MuiInputBase-input': {
              color: 'text.black',
            },
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, m: 1.25, fontSize: (theme: any) => theme.typography.fontSizes.small, color: 'text.blue' }}>
        <Typography
          htmlFor="transportPlan"
          component="label"
          sx={{
            fontSize: (theme: any) => theme.typography.fontSizes.small,
            color: 'text.blue',
          }}
        >
          TRANSPORTO PLANAS
        </Typography>
        <Checkbox 
          id="checkTransportPlan" 
          name="checkTransportPlan"
        />
        <TextInput
          id="transportPlan"
          name="transportPlan"
          size="small"
          sx={{
            borderTop: 0,
            borderRight: 0,
            borderBottom: '1px solid border.medium',
            borderLeft: '1px solid border.medium',
            bgcolor: 'background.lightGrey',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderBottom: '1px solid border.medium',
              borderLeft: '1px solid border.medium',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderBottom: '1px solid border.medium',
              borderLeft: '1px solid border.medium',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
              borderBottom: '1px solid border.medium',
              borderLeft: '1px solid border.medium',
            },
          }}
        />
      </Box>

      <Table
        sx={{
          width: '400px',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          color: '#2563eb',
          fontSize: (theme: any) => theme.typography.fontSizes.small,
        }}
      >
        {/* Table content commented out in original */}
      </Table>
    </Box>
  );
};

export default FormTransportation;
